<template>
  <section>
    <PageTitle title="Customer Babies" v-if="!hidePageTitle"
               v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/customer_babies',title:'Customer Babies'}]"
    />

    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox-content">

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Parent Name</label>
                    <input placeholder="Parent Name" id="customerName" class="form-control" v-model="customerName"/>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Baby Name</label>
                    <input placeholder="Baby Name" id="babyName" class="form-control" v-model="babyName"/>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Select Gender</label>
                    <select v-model="gender" class="form-control styleSelectElement">
                      <option value="" disabled>Select Gender</option>
                      <option :value="'M'">Boy</option>
                      <option :value="'F'">Girl</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <button style="margin-top: 25px;margin-right: 10px" class="btn btn-primary btn-sm search_filter_btn" type="button">
                    <i class="fa fa-search"></i> Search
                  </button>
                  <button style="margin-top: 25px" class="btn btn-info btn-sm refresh_filter_btn" type="button">
                    <i class="fa fa-refresh"></i> Refresh
                  </button>
                </div>
              </div>

            <br/>
            <div class="row">
              <div class="ibox">
                <div class="ibox-content">
                  <div class="table-responsive">
                    <table class="table table-striped table-responsive table-bordered table-hover"
                           id="customerBabyNaming">
                      <thead>
                      <tr>
                        <th>ID</th>
                        <th>Parent Name</th>
                        <th>Baby Name</th>
                        <th>DOB</th>
                        <th>Age</th>
                        <th>Gender</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ViewBabyVaccinationChart showActions="true" ref="viewBabyVaccinationChartComp"/>
    <EditCustomerBabyName ref="editCustomerBabyNames" />
  </section>
</template>

<script>
import PageTitle from "@/components/layout_components/PageTitle.vue";
import Multiselect from "vue-multiselect";
import state from "@/store";
import EditCustomerBabyName from "@/components/CustomerBabies/EditCustomerBabyName.vue";
import ViewBabyVaccinationChart from "@/components/CustomerBabies/ViewBabyVaccinationChart.vue";


export default {
  name: "CustomerBabies",
  components: {ViewBabyVaccinationChart, EditCustomerBabyName, Multiselect, PageTitle},
  data(){
    return {
      customerName: '',
      babyName: '',
      dateOfBirth: '',
      gender: '',
      dataTable:'',
      status:'',
      customerID:0
    }
  },
  computed: {
    role() {
      return this.$store.getters.user.userRolesById[0].role;
    }
  },
  props: {
    hidePageTitle: {
      type: Boolean,
      default: false,
    }
  },
  async mounted() {
    await this.initializeDatatable();
    await this.jQueryOnSearchButton();
    await this.jQueryOnRefreshButton();
  },
  methods: {

    fetchBabyVaccinationDetails: function (orderId, babyName) {
      this.$refs.viewBabyVaccinationChartComp.fetchBabyVaccinationDetails(orderId, babyName);
    },

    calculateAge(dateOfBirth) {
      const today = new Date();
      const birthDate = new Date(dateOfBirth);
      const diffInMilliseconds = today - birthDate;

      const days = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
      const months = Math.floor(days / 30);
      const years = Math.floor(days / 365);

      if (years > 0) {
        return `${years} year(s)`;
      } else if (months > 0) {
        return `${months} month(s)`;
      } else {
        return `${days} day(s)`;
      }
    },


    initializeDatatable: function() {
      let self = this;
      let processingURL = state.getters.mainAppURL + "baby_names/customer_details";

      self.dataTable = $('#customerBabyNaming').DataTable({
        "processing": true,
        "serverSide": true,
        "dom":'ltipr',
        "lengthMenu": [10, 25, 50, 100, 250],
        autoWidth: false,
        "order": [[0, "desc"]],
        'language': {
          'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
              '                <div class="sk-double-bounce1"></div>\n' +
              '                <div class="sk-double-bounce2"></div>\n' +
              '              </div>'
        },
        "ajax": {
          url: processingURL,
          type: "POST",
          data: function (d) {
            // Send DataTables parameters in the request body
            return JSON.stringify(d); // Convert DataTables parameters to JSON
          },
          contentType: "application/json; charset=utf-8",
          headers: {
            "Authorization": 'Bearer ' + this.$store.state.accessToken
          },
          beforeSend:  (xhr) => {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
          },
          statusCode: {
            401: () => {
              this.updateRefreshTokenInDataTable(this.dataTable);
            }
          }
        },
        "columnDefs":[
          {
            "orderable": false, "targets": [1, 2, 3, 4, 5, 6]
          },
          {
            'className': "text-center", 'aTargets': [0, 1, 2, 3, 4, 5, 6]
          },
          {
            "targets": [1, 2, 3, 4, 5], "searchable": false
          },
          { "width": "30%", "targets": 3 }
        ],
        "columns": [
          {
            "data": "id",
            "name": "id",
            "render": function(data, type, row, dataIndex) {
              return (typeof data === 'object' && data !== null) ? JSON.stringify(data) : data;
            }
          },
          {
            "data": "dvmCustomers.name",
            "name": "dvmCustomers.name",
            "render": function(data, type, row) {
              if (self.role === 'ROLE_ADMIN') {
                return "<a class='editName' data-id=" + row.dvmCustomers.id + ">" + data + "</a>";
              } else {
                return "<a href='javascript:void(0)' data-id=" + row.dvmCustomers.id + ">" + data + "</a>";
              }
            }
          },
          {
            "data": "name",
            "name": "name"
          },
          {
            "data": "dateOfBirth",
            "name": "dateOfBirth",
            "render": function (data) {
              let date = new Date(data);
              let formattedDate = date.toLocaleDateString();
              return "<span class='m_tip label label-default'>" + formattedDate + "</span>";
            }
          },
          {
            "data": "age",
            "name": "age",
            "render": function (data, type, row) {
              return self.calculateAge(row.dateOfBirth);
            }
          },
          {
            "data": "gender",
            "name": "gender",
            "render": function (data) {
              if (data === 'M') {
                return "<span class='m_tip label label-info'>Boy</span>";
              } else {
                return "<span class='m_tip label label-danger pink'>Girl</span>";
              }
            }
          },
          {
            "data": "actions",
            "render": function(data, type, row){
              return '<a data-id="'+row.id+'" data-name="'+row.name+'" class="btn btn-xs btn-primary view_btn" href="javascript:void(0)">View</a>';
            },
            "name":"actions"
          },
        ],
        "drawCallback": function(settings) {


          $('.editName').click(function (){
            let id = $(this).attr("data-id");
            console.log("Clicked ID:", id); // Add this line to check if ID is being passed
            self.$refs.editCustomerBabyNames.load(id);
          });

          $(".m_tip").tooltip();
          $(".view_btn").click( function() {
            let babyId = $(this).attr("data-id");
            let babyName = $(this).attr("data-name")
            console.log("Clicked baby ID:", babyId); // Add this line to check if ID is being passed
            self.fetchBabyVaccinationDetails(babyId, babyName);
          });

        }

      });
      $.fn.dataTable.ext.errMode = 'none';
    },

    jQueryOnSearchButton () {
      let self = this;
      $(".search_filter_btn").click(function () {
        self.resetDatatableColumns();

        // Apply the Parent Name filter
        if (self.customerName) {
          self.dataTable.column(1).search(self.customerName);
        }

        // Apply the Baby Name filter
        if (self.babyName) {
          self.dataTable.column(2).search(self.babyName);
        }

        // Apply the Gender filter
        if (self.gender) {
          self.dataTable.column(5).search(self.gender);
        }

        self.dataTable.draw();
      });
    },

    jQueryOnRefreshButton() {
      let self = this;
      $(".refresh_filter_btn").click(function () {
        self.resetDatatableColumns();

        // Reset filter variables
        self.customerName = '';
        self.babyName = '';
        self.gender = '';

        self.dataTable.draw();
      });
    },
    resetDatatableColumns (){
      this.dataTable.column(1).search('');
      this.dataTable.column(2).search('');
      this.dataTable.column(5).search('');
    },
    tableDraw: function () {this.dataTable.draw()},  }
}
</script>

<style>
.pink {
  background-color: #FF92A5 !important;
}
.max-width-100 {
  max-width: 100px;
}
</style>